import React, { useState, useEffect } from "react";
import "./clases.css";

const CATEGORIES = [
  "Crecimiento Espiritual",
  "Panorama biblico",
  "Nueva vida",
  "Seminarios",
  "Predicas"
];

export default function ClasesModal({ isOpen, onClose, onSave, editingLesson }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editingLesson) {
      setTitle(editingLesson.title);
      setDescription(editingLesson.description || "");
      setCategory(editingLesson.category);
      setFile(null); // File is optional on edit
    } else {
      // Reset form
      setTitle("");
      setDescription("");
      setCategory(CATEGORIES[0]);
      setFile(null);
    }
  }, [editingLesson, isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !category || (!file && !editingLesson)) {
      alert("Por favor llena todos los campos obligatorios.");
      return;
    }

    setLoading(true);
    await onSave({ title, description, category, file, id: editingLesson?.id });
    setLoading(false);
  };

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <h2 className="modalTitle">
          {editingLesson ? "Editar Clase" : "Nueva Clase Bíblica"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="formGroup">
            <label>Título de la Clase *</label>
            <input
              type="text"
              className="formInput"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Ej. La Armadura de Dios"
              required
            />
          </div>

          <div className="formGroup">
            <label>Categoría *</label>
            <select
              className="formInput"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              {CATEGORIES.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          <div className="formGroup">
            <label>Descripción</label>
            <textarea
              className="formInput"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Breve resumen de la clase..."
            />
          </div>

          <div className="formGroup">
            <label>Archivo PDF {editingLesson ? "(Opcional si no se cambia)" : "*"}</label>
            <input
              type="file"
              accept="application/pdf"
              className="formInput"
              onChange={(e) => setFile(e.target.files[0])}
              required={!editingLesson}
            />
          </div>

          <div className="modalActions">
            <button type="button" className="cancelBtn" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="saveBtn" disabled={loading}>
              {loading ? "Guardando..." : "Guardar Clase"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
